const read = (value, camelName, pascalName) => (
  value?.[camelName] ?? value?.[pascalName]
);

const itemId = item => String(read(item, 'id', 'Id') || '');
const itemTypeId = item => String(read(item, 'typeId', 'TypeId') || '');

export function salvageLearningDisabledReason(
  item,
  itemTypes,
  starterItemIds = new Set(),
) {
  if (!item) return 'Select an output item first.';
  if (starterItemIds.has(itemId(item))) {
    return 'Starter gear cannot teach recipes.';
  }
  const type = (itemTypes || []).find(candidate => (
    String(read(candidate, 'id', 'Id') || '') === itemTypeId(item)
  ));
  if (Boolean(read(type, 'isConsumable', 'IsConsumable'))) {
    return 'Consumables cannot teach recipes.';
  }
  if (!Boolean(read(type, 'isEquipment', 'IsEquipment'))) {
    return 'Materials and other non-equipment cannot teach recipes.';
  }
  return '';
}
